import { XMarkIcon } from "@heroicons/react/24/solid";
import { useState, useEffect } from "react";
import FilterTextInput from "../FilterTextInput";
import LoadingInComponent from "../LoadingInComponent";
import GuestCard from "./GuestCard";
import { Filter, Trash } from "iconsax-react";

const CheckInSliderStep1 = ({
  loading,
  searchTerm,
  setIsOpen,
  filteredGuestList,
  handleSearch,
  handleRecordClick,
  tagList,
  selectedTags,
  setSelectedTags,
  inputRef,
}) => {
  const [dropDownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  return (
    <div className="absolute right-0 top-0 flex flex-col bg-white w-full h-screen no-scrollbar overflow-y-auto">
      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full p-[24px] gap-[24px] border-b border-[#EFF0F2]">
          <div className="flex w-full justify-between">
            <div>
              <h2 className="w-full text-[17px]">Guest List</h2>
              <p className="text-[14px] text-[#636C7E] font-normal">
                Search by guest name, email, contact, or group name.
              </p>
            </div>
            <XMarkIcon
              className="size-[24px] hover:cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="relative flex w-full items-center gap-[6px]">
            <FilterTextInput
              ref={inputRef}
              value={searchTerm}
              onChange={handleSearch}
              className="w-full"
            />
            <Filter
              size="32"
              color="#5C4BF5"
              variant="Bold"
              className="cursor-pointer"
              onClick={() => {
                setDropdownOpen(!dropDownOpen);
              }}
            />
            {dropDownOpen && (
              <div className="absolute right-0 top-12 p-1 bg-white shadow-lg z-20 rounded-lg font-normal">
                {tagList && tagList.length > 0 ? (
                  <div className="flex flex-col gap-1">
                    {tagList.map((tag) => (
                      <div className="flex gap-2 items-center p-2" key={tag.id}>
                        <input
                          type="checkbox"
                          checked={selectedTags.includes(tag.id)}
                          className="accent-[#5C4BF5] w-4 h-4"
                          onChange={() => {
                            if (selectedTags.includes(tag.id)) {
                              setSelectedTags(
                                selectedTags.filter((id) => id !== tag.id)
                              );
                            } else {
                              setSelectedTags([...selectedTags, tag.id]);
                            }
                          }}
                        />{" "}
                        {tag.name}
                        <span className="text-[11px] font-medium px-[6px] py-[2px] text-[#5C4BF5] bg-[#EFEDFE] border border-[#DEDBFD] rounded-md">
                          {tag.guests_count}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>No tags available</div>
                )}
              </div>
            )}
          </div>
          <p className="flex items-center font-normal gap-1">
            <span className="font-bold">{filteredGuestList.length}</span>{" "}
            Results
          </p>
          {selectedTags && selectedTags.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {selectedTags.map((tagId) => (
                <span
                  className="flex items-center gap-2 bg-[#EFF0F2] rounded-full px-3 py-[6px]"
                  key={tagId}
                >
                  {tagList.find((tag) => tag.id === tagId)?.name}
                  <XMarkIcon
                    className="size-[12px] cursor-pointer"
                    onClick={() => {
                      setSelectedTags(
                        selectedTags.filter((id) => id !== tagId)
                      );
                    }}
                  />
                </span>
              ))}
              <span
                className="flex items-center gap-2 cursor-pointer text-[#FF3030]"
                onClick={() => {
                  setSelectedTags([]);
                }}
              >
                <Trash size="12" variant="Bold" />
                Clear All
              </span>
            </div>
          )}
        </div>

        {filteredGuestList && (
          <div className="flex flex-col w-full p-[24px] gap-[8px]">
            {filteredGuestList.map((guest, index) => (
              <GuestCard
                key={index}
                data={guest}
                onClick={() => handleRecordClick(guest.uuid)}
              />
            ))}
          </div>
        )}
      </LoadingInComponent>
    </div>
  );
};

export default CheckInSliderStep1;
